import COM from './CarouselGallery'

export default COM
